import { FEED_REQUEST, FEED_SUCCESS, FEED_FAILURE } from '../constants/ActionTypes';

const initialState = {
  loading: false,
};

function feed(state = initialState, action) {
  switch (action.type) {
    case FEED_REQUEST:
      return { ...state, loading: true };
    case FEED_SUCCESS:
      return { ...state, loading: false, ...action.feed };
    case FEED_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
}

export default feed;
